export default function (state) {
    state.id = 0;
    state.type = 'add';
    state.tab = 'main';
    state.visible = true;
    state.loading = false;
}